import { render, staticRenderFns } from "./ShippingMethod.vue?vue&type=template&id=227bf4f3&scoped=true"
import script from "./ShippingMethod.vue?vue&type=script&lang=js"
export * from "./ShippingMethod.vue?vue&type=script&lang=js"
import style0 from "./ShippingMethod.vue?vue&type=style&index=0&id=227bf4f3&prod&lang=scss&scoped=true"
import style1 from "./ShippingMethod.vue?vue&type=style&index=1&id=227bf4f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227bf4f3",
  null
  
)

export default component.exports